/* eslint-disable */
import GraphQL from '../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type IsDeliveryAddressEnabledQueryVariables = GraphQL.Exact<{
  accountId: GraphQL.Scalars['AccountId']['input'];
}>;


export type IsDeliveryAddressEnabledQuery = { readonly __typename?: 'Query', readonly account: { readonly __typename?: 'Account', readonly id: CK.AccountId, readonly isDeliveryAddressEnabled: boolean } | null };


export const IsDeliveryAddressEnabledDocument = gql`
    query IsDeliveryAddressEnabled($accountId: AccountId!) {
  account(id: $accountId) {
    id
    isDeliveryAddressEnabled
  }
}
    `;

/**
 * __useIsDeliveryAddressEnabledQuery__
 *
 * To run a query within a React component, call `useIsDeliveryAddressEnabledQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsDeliveryAddressEnabledQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsDeliveryAddressEnabledQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useIsDeliveryAddressEnabledQuery(baseOptions: Apollo.QueryHookOptions<IsDeliveryAddressEnabledQuery, IsDeliveryAddressEnabledQueryVariables> & ({ variables: IsDeliveryAddressEnabledQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsDeliveryAddressEnabledQuery, IsDeliveryAddressEnabledQueryVariables>(IsDeliveryAddressEnabledDocument, options);
      }
export function useIsDeliveryAddressEnabledLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsDeliveryAddressEnabledQuery, IsDeliveryAddressEnabledQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsDeliveryAddressEnabledQuery, IsDeliveryAddressEnabledQueryVariables>(IsDeliveryAddressEnabledDocument, options);
        }
export function useIsDeliveryAddressEnabledSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IsDeliveryAddressEnabledQuery, IsDeliveryAddressEnabledQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IsDeliveryAddressEnabledQuery, IsDeliveryAddressEnabledQueryVariables>(IsDeliveryAddressEnabledDocument, options);
        }
export type IsDeliveryAddressEnabledQueryHookResult = ReturnType<typeof useIsDeliveryAddressEnabledQuery>;
export type IsDeliveryAddressEnabledLazyQueryHookResult = ReturnType<typeof useIsDeliveryAddressEnabledLazyQuery>;
export type IsDeliveryAddressEnabledSuspenseQueryHookResult = ReturnType<typeof useIsDeliveryAddressEnabledSuspenseQuery>;
export type IsDeliveryAddressEnabledQueryResult = Apollo.QueryResult<IsDeliveryAddressEnabledQuery, IsDeliveryAddressEnabledQueryVariables>;